import InfoIcon from '@mui/icons-material/Info';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import SyncIcon from '@mui/icons-material/Sync';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import React from 'react';

import { FlexBox, FlexBoxProps } from '_lib/components/FlexBox/FlexBox';
import { IconButton } from '_lib/components/IconButton/IconButton';
import { Stack } from '_lib/components/Stack/Stack';
import { Tooltip } from '_lib/components/Tooltip/Tooltip';
import { Typography, TypographyProps } from '_lib/components/Typography/Typography';
import { toSxArray } from '_lib/utils/helpers';

export type HeaderBoxProps = FlexBoxProps & {
  headerText: string;
  infoIconText?: string;
  syncIconText?: string;
  liveIconText?: string;
  visibilityIcon?: {
    isVisible: boolean;
    onToggleVisibility: () => void;
  };
  typographyProps?: TypographyProps;
};

export const HeaderBox = (props: HeaderBoxProps) => {
  const {
    typographyProps,
    infoIconText,
    syncIconText,
    liveIconText,
    visibilityIcon,
    headerText,
    children,
    sx,
    ...boxProps
  } = props;

  return (
    <FlexBox sx={[...toSxArray(sx), { flexDirection: 'column' }]} {...boxProps}>
      <Stack direction='row' sx={{ alignItems: 'center', minHeight: '20px' }}>
        <Typography variant='body1Bold' {...typographyProps} text={headerText} />
        {infoIconText && (
          <Tooltip title={infoIconText} placement={'top-end'}>
            <InfoIcon fontSize='small' color='primary' />
          </Tooltip>
        )}
        {syncIconText && (
          <Tooltip title={syncIconText} placement={'top-end'}>
            <SyncIcon
              fontSize='small'
              color='primaryInverted'
              sx={(theme) => ({ backgroundColor: theme.palette.primary.main, borderRadius: '50%', padding: 0.25 })}
            />
          </Tooltip>
        )}
        {liveIconText && (
          <Tooltip title={liveIconText} placement={'top-end'}>
            <OfflineBoltIcon fontSize='small' color='primary' />
          </Tooltip>
        )}
        {typeof visibilityIcon?.isVisible === 'boolean' && (
          <IconButton onClick={visibilityIcon.onToggleVisibility} size='small' color='primary'>
            {visibilityIcon.isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </IconButton>
        )}
      </Stack>
      {children}
    </FlexBox>
  );
};
